export default __webpack_public_path__ + "static/route_68_bunker-f0761a27e8f301bdb6210499a1c3ef06.png";